import { render, staticRenderFns } from "./pop-video.vue?vue&type=template&id=4dba81e2&scoped=true"
import script from "./pop-video.vue?vue&type=script&lang=js"
export * from "./pop-video.vue?vue&type=script&lang=js"
import style0 from "./pop-video.vue?vue&type=style&index=0&id=4dba81e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba81e2",
  null
  
)

export default component.exports